import { FunctionComponent, useContext } from "react";

import { useAppDispatch, useAppSelector } from "./store/hooks";
import { clearLastPointClicked } from "./store/lastPointClickedSlice";
import { clearProvisionalMoves } from "./store/provisionalMovesSlice";
import { Move, Player } from "./Types";
import { enqueueAnimatableMoves } from "./store/animatableMovesSlice";
import { getInverseMove } from "./store/moves";
import { ActionsContext, LocalGameActions } from "./ActionsContext";
import { isCurrentPlayer } from "./Utils";

const UndoMoveButton: FunctionComponent = () => {
  const [provisionalMoves, currentPlayer, players] = useAppSelector((state) => [
    state.provisionalMoves,
    state.currentPlayer,
    state.players,
  ]);
  const actions = useContext(ActionsContext);
  const dispatch = useAppDispatch();

  // В локальной игре с ботом: кнопка видна только когда ход игрока (Player.One).
  // В сетевой: только когда это наш ход.
  const isLocal = actions instanceof LocalGameActions;
  const isMyTurn = isLocal
    ? currentPlayer === Player.One
    : (players.playerOne != null && players.playerTwo != null &&
       isCurrentPlayer(players, currentPlayer, actions));

  const shouldHide = !isMyTurn || provisionalMoves.length <= 0;

  return (
    <div className={"Undo-button-wrapper"}>
      <div
        className={"Undo-button"}
        hidden={shouldHide}
        onClick={() => {
          if (shouldHide) return;
          let movesToAnimate: Move[] = [];

          for (let i = provisionalMoves.length - 1; i >= 0; i--) {
            movesToAnimate.push(getInverseMove(provisionalMoves[i]));
          }

          dispatch(enqueueAnimatableMoves(movesToAnimate));
          dispatch(clearProvisionalMoves());
          dispatch(clearLastPointClicked());
        }}
      />
    </div>
  );
};

export default UndoMoveButton;
